module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ContactBox":{"heading":"Martin Čáslava","position":"poradenství, obchod, reklamace","content":"+420 725 710 211 | info@oknadverenamiru.cz<br>Po-Pá 9:00-15:00, polední přestávka: 12:00-13:00","image":"/assets/images/martin-caslava.webp"}}}')
  delete Component.options._Ctor
}
